var checkExpireIn = function checkExpireIn(storage) {
  var date = new Date();
  var expireIn = storage == null ? void 0 : storage.expireIn;
  return expireIn === 'non-expirable' ? false : date.getTime() > expireIn;
};
export default checkExpireIn;